import { IViewModel } from "../../interfaces/view-model.interface";

export class InlineContent implements IViewModel {
    public id = 0;
}
